import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../shell/AppShell';

/**
 * /unified/for-restaurants — marketing pitch for restaurant operators.
 *
 * The feat-branch version pointed at a standalone `ForRestaurantsScreen`
 * which doesn't exist on this baseline. Until that screen is built,
 * renders a minimal go-live placeholder so the route is reachable and
 * the CTA on the landing page doesn't 404. A proper marketing page
 * should replace this in a follow-up.
 */
export default function UnifiedForRestaurants() {
  const navigate = useNavigate();
  return (
    <AppShell dense>
      <div style={{
        maxWidth: 720, margin: '0 auto', padding: '80px 24px',
        textAlign: 'center', color: 'var(--cwm-ink)',
      }}>
        <div style={{
          display: 'inline-block', padding: '6px 14px', borderRadius: 999,
          background: 'var(--cwm-blue-pale)', color: 'var(--cwm-blue-deep)',
          fontSize: 11, fontWeight: 900, letterSpacing: '0.14em',
          textTransform: 'uppercase', marginBottom: 16,
        }}>
          For Business
        </div>
        <h1 style={{
          fontSize: 44, fontWeight: 900, letterSpacing: '-0.025em',
          lineHeight: 1.08, margin: '0 0 12px',
        }}>
          List your restaurant on Chat With Menu.
        </h1>
        <p style={{
          fontSize: 16, fontWeight: 500, lineHeight: 1.55,
          color: 'var(--cwm-gray-700)', maxWidth: 560, margin: '0 auto 32px',
        }}>
          Diners with allergies find you first. Free to get listed.
          Upgrade for analytics + hands-on support when you outgrow it.
        </p>
        <div style={{ display: 'inline-flex', gap: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            type="button"
            onClick={() => navigate('/unified/restaurant-pricing')}
            style={{
              padding: '14px 28px', borderRadius: 999,
              background: 'linear-gradient(90deg, #1E9BFF, #0F7FE8)',
              color: '#fff', border: 'none', cursor: 'pointer',
              fontFamily: 'var(--cwm-font)', fontSize: 15, fontWeight: 900,
              boxShadow: '0 10px 26px rgba(15,127,232,0.3)',
            }}>
            See restaurant pricing →
          </button>
          <button
            type="button"
            onClick={() => navigate('/unified/add-restaurant')}
            style={{
              padding: '14px 24px', borderRadius: 999,
              background: '#fff', color: 'var(--cwm-blue-deep)',
              border: '1.5px solid var(--cwm-blue-light)',
              cursor: 'pointer',
              fontFamily: 'var(--cwm-font)', fontSize: 14, fontWeight: 800,
            }}>
            Add your restaurant
          </button>
        </div>
      </div>
    </AppShell>
  );
}
